import { Box } from "@mui/material";
import watermark from ".././assets/images/logoT.png";

const Watermark = () => {
  return (
    <Box
      aria-hidden
      sx={{
        position: "absolute",
        top: -30,
        right: 0,
        opacity: 0.09,
        pointerEvents: "none",
      }}
    >
      <img src={watermark} alt="" width={220} />
    </Box>
  );
};

export default Watermark;
